<template>
  <v-app :style="{background: $vuetify.theme.themes[theme].background}">
    <Login v-if="!store.user.uid"/>
    <v-app-bar v-if="store.user.uid" app color="white" dark>
      <div class="d-flex align-center">
        <v-img alt="Sous Chef Logo" :src="require('./assets/logo.png')" width="200"/>
      </div>
      <v-spacer></v-spacer>
      <v-menu :nudge-width="230" offset-y class="ml-4">
        <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <v-avatar size="40" color="primary">
              <img :src="store.user.photoURL" alt="Avatar">
            </v-avatar>
          </v-toolbar-title>
        </template>

        <v-list>
          <v-list-item>
            <div class="user-card">
              <v-avatar size="66" color="primary">
                <img :src="store.user.photoURL" alt="Avatar">
              </v-avatar>

              <div class="user-card-info">
                <span>{{ store.user.name }}</span>
                <span class="email">{{ store.user.email }}</span>
              </div>
            </div>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>{{ store.user.organizationName }}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="viewAnalytics()">
            <v-list-item-title>View Analytics</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="signOut()">
            <v-list-item-title>Sign out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content v-if="store.user.uid">
      <Dashboard/>
    </v-content>
  </v-app>
</template>

<script>
import Login from './components/Login'
import Dashboard from './components/Dashboard'
import { mapState } from 'vuex'

export default {
  name: 'App',

  components: {
    Login, Dashboard
  },

  data: () => ({
    //
  }),
  methods: {
    viewAnalytics () {
      window.open('https://datastudio.google.com/u/1/reporting/1O1AnS98XNeBCcyDVvRan6F6zV-vjyhKM/page/AxMIB', '_blank')
    },
    signOut () {
      this.$store.commit('signOut')
    }
  },
  computed: {
    theme () {
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    ...mapState(['app', 'store'])
  }
}
</script>
<style lang="scss" scoped>

  .user-card {
    padding: 8px 20px;
    display: flex;
    align-items: center;
    background: white;

    .v-avatar {
      margin-left: 16px;
      margin-top: 8px;
      margin-right: 16px;
      margin-bottom: 4px;
    }

    .user-card-info {
      display: flex;
      flex-flow: column;
      flex: 1;
    }

    .email {
      padding-top: 0px;
      font-size: 13px;
      font-weight: normal;
    }

    span {
      padding-top: 8px;
      font-weight: bold;
      font-size: 16px;
    }
  }
</style>
